
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import ImageFont from '@devsisters/ui-common/lib/ImageFont';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"imagefont"}}>{`ImageFont`}</MDXTag>
<MDXTag name="p" components={components}>{`이미지로 만들어진 폰트로 텍스트를 그리고 싶은 경우에 사용합니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { ImageFont } from '@devsisters/ui-common';
// 또는 import ImageFont from '@devsisters/ui-common/lib/ImageFont';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'() => {\n  return (\n    <span style={{ fontSize: \'20px\' }}>\n      <ImageFont glyphInfos={glyphInfos()}>\n        hello 한글 world! 테스트 0123456789\n      </ImageFont>\n    </span>\n  )\n  function glyphInfos() {\n    const glyph = (x, y, w, h) => ({\n      x,\n      y,\n      w,\n      h,\n      // 이미지 출처: https://webglfundamentals.org/webgl/lessons/webgl-text-glyphs.html\n      src:\n        \'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a29e2d80-c5e8-11e8-a9ff-6b03f28f121b.png\',\n      style: { marginRight: \'-0.15em\' },\n    })\n    return {\n      a: glyph(0, 0, 8, 8),\n      b: glyph(8, 0, 8, 8),\n      c: glyph(16, 0, 8, 8),\n      d: glyph(24, 0, 8, 8),\n      e: glyph(32, 0, 8, 8),\n      f: glyph(40, 0, 8, 8),\n      g: glyph(48, 0, 8, 8),\n      h: glyph(56, 0, 8, 8),\n      i: glyph(0, 8, 8, 8),\n      j: glyph(8, 8, 8, 8),\n      k: glyph(16, 8, 8, 8),\n      l: glyph(24, 8, 8, 8),\n      m: glyph(32, 8, 8, 8),\n      n: glyph(40, 8, 8, 8),\n      o: glyph(48, 8, 8, 8),\n      p: glyph(56, 8, 8, 8),\n      q: glyph(0, 16, 8, 8),\n      r: glyph(8, 16, 8, 8),\n      s: glyph(16, 16, 8, 8),\n      t: glyph(24, 16, 8, 8),\n      u: glyph(32, 16, 8, 8),\n      v: glyph(40, 16, 8, 8),\n      w: glyph(48, 16, 8, 8),\n      x: glyph(56, 16, 8, 8),\n      y: glyph(0, 24, 8, 8),\n      z: glyph(8, 24, 8, 8),\n      \'0\': glyph(16, 24, 8, 8),\n      \'1\': glyph(24, 24, 8, 8),\n      \'2\': glyph(32, 24, 8, 8),\n      \'3\': glyph(40, 24, 8, 8),\n      \'4\': glyph(48, 24, 8, 8),\n      \'5\': glyph(56, 24, 8, 8),\n      \'6\': glyph(0, 32, 8, 8),\n      \'7\': glyph(8, 32, 8, 8),\n      \'8\': glyph(16, 32, 8, 8),\n      \'9\': glyph(24, 32, 8, 8),\n      \'-\': glyph(32, 32, 8, 8),\n      \'*\': glyph(40, 32, 8, 8),\n      \'!\': glyph(48, 32, 8, 8),\n      \'?\': glyph(56, 32, 8, 8),\n    }\n  }\n}'} __scope={{props: this ? this.props : props,ImageFont}}>
  {() => {
    return <span style={{ fontSize: '20px' }}>
      <ImageFont glyphInfos={glyphInfos()}>
        hello 한글 world! 테스트 0123456789
      </ImageFont>
    </span>;
    function glyphInfos() {
      const glyph = (x, y, w, h) => ({
        x, y, w, h,
        // 이미지 출처: https://webglfundamentals.org/webgl/lessons/webgl-text-glyphs.html
        src: 'https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a29e2d80-c5e8-11e8-a9ff-6b03f28f121b.png',
        style: { marginRight: '-0.15em' },
      });
      return {
        'a': glyph( 0,  0, 8, 8),
        'b': glyph( 8,  0, 8, 8),
        'c': glyph(16,  0, 8, 8),
        'd': glyph(24,  0, 8, 8),
        'e': glyph(32,  0, 8, 8),
        'f': glyph(40,  0, 8, 8),
        'g': glyph(48,  0, 8, 8),
        'h': glyph(56,  0, 8, 8),
        'i': glyph( 0,  8, 8, 8),
        'j': glyph( 8,  8, 8, 8),
        'k': glyph(16,  8, 8, 8),
        'l': glyph(24,  8, 8, 8),
        'm': glyph(32,  8, 8, 8),
        'n': glyph(40,  8, 8, 8),
        'o': glyph(48,  8, 8, 8),
        'p': glyph(56,  8, 8, 8),
        'q': glyph( 0, 16, 8, 8),
        'r': glyph( 8, 16, 8, 8),
        's': glyph(16, 16, 8, 8),
        't': glyph(24, 16, 8, 8),
        'u': glyph(32, 16, 8, 8),
        'v': glyph(40, 16, 8, 8),
        'w': glyph(48, 16, 8, 8),
        'x': glyph(56, 16, 8, 8),
        'y': glyph( 0, 24, 8, 8),
        'z': glyph( 8, 24, 8, 8),
        '0': glyph(16, 24, 8, 8),
        '1': glyph(24, 24, 8, 8),
        '2': glyph(32, 24, 8, 8),
        '3': glyph(40, 24, 8, 8),
        '4': glyph(48, 24, 8, 8),
        '5': glyph(56, 24, 8, 8),
        '6': glyph( 0, 32, 8, 8),
        '7': glyph( 8, 32, 8, 8),
        '8': glyph(16, 32, 8, 8),
        '9': glyph(24, 32, 8, 8),
        '-': glyph(32, 32, 8, 8),
        '*': glyph(40, 32, 8, 8),
        '!': glyph(48, 32, 8, 8),
        '?': glyph(56, 32, 8, 8),
      };
    }
  }}
</Playground>
<MDXTag name="h2" components={components} props={{"id":"협업-노트"}}>{`협업 노트`}</MDXTag>
<MDXTag name="p" components={components}>{`이미지 폰트를 요청하는 디자이너는 다음과 같은 느낌의 시트 파일과,
각 글리프(글자 모양)이 시트의 어디에 해당하는지를 나타내는 위치정보를 작업해주셔야 합니다.`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"이미지-파일-예시"}}>{`이미지 파일 예시`}</MDXTag>
<img
  width={64 * 2}
  height={40 * 2}
  style={{ imageRendering: 'pixelated' }}
  src='https://d1oiqh6jpsob51.cloudfront.net/devscookie.com/file/temp/a29e2d80-c5e8-11e8-a9ff-6b03f28f121b.png'
/>
<MDXTag name="p" components={components}>{`(위 이미지는 `}<MDXTag name="a" components={components} parentName="p" props={{"href":"https://webglfundamentals.org/webgl/lessons/webgl-text-glyphs.html"}}>{`https://webglfundamentals.org/webgl/lessons/webgl-text-glyphs.html`}</MDXTag>{`에서 가져온 무료 이미지입니다)`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"각-글리프가-시트의-어디를-나타내는건지-알-수-있는-위치정보-예시픽셀-단위-사용"}}>{`각 글리프가 시트의 어디를 나타내는건지 알 수 있는 위치정보 예시(픽셀 단위 사용)`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-json"}}>{`{
  "a": {"x":  0, "y":  0, "w": 8, "h": 8},
  "b": {"x":  8, "y":  0, "w": 8, "h": 8},
  "c": {"x": 16, "y":  0, "w": 8, "h": 8},
  "d": {"x": 24, "y":  0, "w": 8, "h": 8},
  "e": {"x": 32, "y":  0, "w": 8, "h": 8},
  "f": {"x": 40, "y":  0, "w": 8, "h": 8},
  "g": {"x": 48, "y":  0, "w": 8, "h": 8},
  "h": {"x": 56, "y":  0, "w": 8, "h": 8},
  "i": {"x":  0, "y":  8, "w": 8, "h": 8},
  "j": {"x":  8, "y":  8, "w": 8, "h": 8},
  "k": {"x": 16, "y":  8, "w": 8, "h": 8},
  "l": {"x": 24, "y":  8, "w": 8, "h": 8},
  "m": {"x": 32, "y":  8, "w": 8, "h": 8},
  "n": {"x": 40, "y":  8, "w": 8, "h": 8},
  "o": {"x": 48, "y":  8, "w": 8, "h": 8},
  "p": {"x": 56, "y":  8, "w": 8, "h": 8},
  "q": {"x":  0, "y": 16, "w": 8, "h": 8},
  "r": {"x":  8, "y": 16, "w": 8, "h": 8},
  "s": {"x": 16, "y": 16, "w": 8, "h": 8},
  "t": {"x": 24, "y": 16, "w": 8, "h": 8},
  "u": {"x": 32, "y": 16, "w": 8, "h": 8},
  "v": {"x": 40, "y": 16, "w": 8, "h": 8},
  "w": {"x": 48, "y": 16, "w": 8, "h": 8},
  "x": {"x": 56, "y": 16, "w": 8, "h": 8},
  "y": {"x":  0, "y": 24, "w": 8, "h": 8},
  "z": {"x":  8, "y": 24, "w": 8, "h": 8},
  "0": {"x": 16, "y": 24, "w": 8, "h": 8},
  "1": {"x": 24, "y": 24, "w": 8, "h": 8},
  "2": {"x": 32, "y": 24, "w": 8, "h": 8},
  "3": {"x": 40, "y": 24, "w": 8, "h": 8},
  "4": {"x": 48, "y": 24, "w": 8, "h": 8},
  "5": {"x": 56, "y": 24, "w": 8, "h": 8},
  "6": {"x":  0, "y": 32, "w": 8, "h": 8},
  "7": {"x":  8, "y": 32, "w": 8, "h": 8},
  "8": {"x": 16, "y": 32, "w": 8, "h": 8},
  "9": {"x": 24, "y": 32, "w": 8, "h": 8},
  "-": {"x": 32, "y": 32, "w": 8, "h": 8},
  "*": {"x": 40, "y": 32, "w": 8, "h": 8},
  "!": {"x": 48, "y": 32, "w": 8, "h": 8},
  "?": {"x": 56, "y": 32, "w": 8, "h": 8}
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  